import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Navbar = () => {
	const { user, logout } = useAuth();
	const navigate = useNavigate();
	const baseUrl = process.env.REACT_APP_BASE_URL || '/';

	const handleLogout = async () => {
		await logout();
		navigate(`${baseUrl}login`);
	};

	return (
		<nav className="navbar navbar-expand-lg navbar-light bg-light sticky-top">
			<div className="collapse navbar-collapse justify-content-end">
				<ul className="navbar-nav">
					{user ? (
						<>
							<li className="nav-item">
								<span className="navbar-text">
									You are logged in as {user.username}
								</span>
							</li>
							<li className="nav-item">
								<button className="btn btn-primary ml-2" onClick={handleLogout}>
									Logout
								</button>
							</li>
						</>
					) : (
						<li className="nav-item">
							<a className="nav-link" href={`${baseUrl}login`}>
								Login
							</a>
						</li>
					)}
				</ul>
			</div>
		</nav>
	);
};

export default Navbar;
